/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import map from 'lodash/map';
import get from 'lodash/get';
import Input from 'zignal-landscape/lib/Input';
import DateRangePicker from 'zignal-landscape/lib/DateRangePicker';
import Select from 'zignal-landscape/lib/Select';
import themeable from 'zignal-landscape/lib/themeable';

const WidgetSettingComponent = (props) => {
  const {
    type,
    colName,
    settingValue,
    setSetting,
    profileOptions,
    smartFilters,
    selected,
    timezone,
    datePickerMinDate
  } = props;

  const handleInputChange = (e) => {
    const {
      name,
      value
    } = e.target;
    setSetting({name, value});
  };

  const renderSettingComponent = () => {
    let placeholder;
    let selectValue;
    switch (type) {
      case 'text':
        placeholder = colName === 'title' ? 'Title': 'Subtitle';
        return (<Input
          id={`input_${colName}`}
          data-cy={`input_${colName}`}
          name={colName}
          disabled={!selected}
          value={settingValue}
          placeholder={`Enter ${placeholder}`}
          onChange={handleInputChange}
        />);

      case 'select':
      case 'select-multi':{
        selectValue =  type ==='select-multi' ?
          map(settingValue, (id) => find(profileOptions, {value: id}))
          :find(profileOptions, {value : settingValue});

        return (<Select
          id={`wizard_select_${colName}`}
          data-cy={`wizard_select_${colName}`}
          placeholder={'Select Dataset'}
          options={profileOptions}
          value={selectValue}
          isDisabled={!selected}
          onChange={(selectedOptions) => {
            //Include all handlig
            if(type ==='select-multi'){
              const value = map(selectedOptions, 'value');
              const payload = {name:colName, value, includeAll: value.length === profileOptions.length};
              setSetting(payload);
              return;
            }
            setSetting({name:colName, value: get(selectedOptions, 'value', '')});
          }}
          isMulti={type ==='select-multi'}
          isClearable
        />);
      }

      case 'daterangepicker':
        return (<DateRangePicker
          inputDisplayFormat={'MM/DD/YYYY h:mma'}
          clearable
          startEndDates={settingValue}
          disabled={!selected}
          timezone={timezone}
          placeholder={'Dashboard Date Range'}
          minDate={datePickerMinDate}
          isOutsideRange={(day) => {
            const now = moment.tz(timezone); // eslint-disable-line
            const isBeforeMinDate = day.isBefore(datePickerMinDate.startOf('day'));
            const isAfterMaxDate = day.isAfter(now.endOf('day'));
            return isBeforeMinDate || isAfterMaxDate;
          }}
          onChange={(dateRange) => {
            setSetting({name: 'dateRange_option', value: dateRange});
          }}
        />);

      case 'smartfilter':
        return (<Select
          id={'wizard_smartfilter'}
          data-cy={`wizard_select_${colName}`}
          placeholder={'Select Smart Filter'}
          isDisabled={!selected}
          options={smartFilters}
          value={find(smartFilters, {value : settingValue})}
          onChange={(smartFilter) => {
            const smartFilterId = get(smartFilter, 'value', '');
            setSetting({name: 'widget_filter', value: smartFilterId});
          }}
          isClearable
        />);

      default: return null;
    }
    return null;
  };

  return(
    <React.Fragment>
      {renderSettingComponent()}
    </React.Fragment>
  );
};

WidgetSettingComponent.propTypes = {
  type: PropTypes.string,
  colName:  PropTypes.string,
  settingValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  setSetting: PropTypes.func,
  profileOptions:  PropTypes.array,
  smartFilters:  PropTypes.array,
  selected: PropTypes.bool.isRequired,
  timezone: PropTypes.string.isRequired,
  datePickerMinDate: PropTypes.object,
};

export default themeable(WidgetSettingComponent);
